/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Platform_Header_TitleInputs */

const en_platform_header_title = /** @type {((inputs: Platform_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.name} API`)
		}),
		{
			parts: /** @type {(inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.name) }, { type: "text", value: " " }, { type: "markup-start", name: "accent", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "accent", options: {}, attributes: {} }])
			})
		}
	)
);

const zh_hans1_platform_header_title = /** @type {((inputs: Platform_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.name} API`)
		}),
		{
			parts: /** @type {(inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.name) }, { type: "text", value: " " }, { type: "markup-start", name: "accent", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "accent", options: {}, attributes: {} }])
			})
		}
	)
);

const pt_br2_platform_header_title = /** @type {((inputs: Platform_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`API para ${i?.name}`)
		}),
		{
			parts: /** @type {(inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "accent", options: {}, attributes: {} }, { type: "text", value: "API para" }, { type: "markup-end", name: "accent", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.name) }])
			})
		}
	)
);

const es_platform_header_title = /** @type {((inputs: Platform_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`API de ${i?.name}`)
		}),
		{
			parts: /** @type {(inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "accent", options: {}, attributes: {} }, { type: "text", value: "API de" }, { type: "markup-end", name: "accent", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.name) }])
			})
		}
	)
);

const fr_platform_header_title = /** @type {((inputs: Platform_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.name} API`)
		}),
		{
			parts: /** @type {(inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.name) }, { type: "text", value: " " }, { type: "markup-start", name: "accent", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "accent", options: {}, attributes: {} }])
			})
		}
	)
);

const de_platform_header_title = /** @type {((inputs: Platform_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.name}-API`)
		}),
		{
			parts: /** @type {(inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.name) }, { type: "text", value: "-" }, { type: "markup-start", name: "accent", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "accent", options: {}, attributes: {} }])
			})
		}
	)
);

const ru_platform_header_title = /** @type {((inputs: Platform_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.name} API`)
		}),
		{
			parts: /** @type {(inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.name) }, { type: "text", value: " " }, { type: "markup-start", name: "accent", options: {}, attributes: {} }, { type: "text", value: "API" }, { type: "markup-end", name: "accent", options: {}, attributes: {} }])
			})
		}
	)
);

const it_platform_header_title = /** @type {((inputs: Platform_Header_TitleInputs) => LocalizedString) & { parts: (inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Header_TitleInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`API di ${i?.name} `)
		}),
		{
			parts: /** @type {(inputs: Platform_Header_TitleInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "API di " }, { type: "text", value: String(i?.name) }, { type: "text", value: " " }, { type: "markup-start", name: "accent", options: {}, attributes: {} }, { type: "markup-end", name: "accent", options: {}, attributes: {} }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "{name} API" |
*
* @param {Platform_Header_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_header_title = /** @type {((inputs: Platform_Header_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs: Platform_Header_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Platform_Header_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { accent: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Platform_Header_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_platform_header_title(inputs)
			if (locale === "pt-BR") return pt_br2_platform_header_title(inputs)
			if (locale === "es") return es_platform_header_title(inputs)
			if (locale === "fr") return fr_platform_header_title(inputs)
			if (locale === "de") return de_platform_header_title(inputs)
			if (locale === "ru") return ru_platform_header_title(inputs)
			if (locale === "it") return it_platform_header_title(inputs)
			return en_platform_header_title(inputs)
		}),
		{
			parts: /** @type {(inputs: Platform_Header_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_platform_header_title.parts === "function" ? zh_hans1_platform_header_title.parts(inputs) : [{ type: "text", value: zh_hans1_platform_header_title(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_platform_header_title.parts === "function" ? pt_br2_platform_header_title.parts(inputs) : [{ type: "text", value: pt_br2_platform_header_title(inputs) }]
				if (locale === "es") return typeof es_platform_header_title.parts === "function" ? es_platform_header_title.parts(inputs) : [{ type: "text", value: es_platform_header_title(inputs) }]
				if (locale === "fr") return typeof fr_platform_header_title.parts === "function" ? fr_platform_header_title.parts(inputs) : [{ type: "text", value: fr_platform_header_title(inputs) }]
				if (locale === "de") return typeof de_platform_header_title.parts === "function" ? de_platform_header_title.parts(inputs) : [{ type: "text", value: de_platform_header_title(inputs) }]
				if (locale === "ru") return typeof ru_platform_header_title.parts === "function" ? ru_platform_header_title.parts(inputs) : [{ type: "text", value: ru_platform_header_title(inputs) }]
				if (locale === "it") return typeof it_platform_header_title.parts === "function" ? it_platform_header_title.parts(inputs) : [{ type: "text", value: it_platform_header_title(inputs) }]
				return typeof en_platform_header_title.parts === "function" ? en_platform_header_title.parts(inputs) : [{ type: "text", value: en_platform_header_title(inputs) }]
			})
		}
	)
);